import createDisplayName from "../../../fabrics/createDisplayName";
import { MEDIA_DISPLAY_NAME } from "../Media";

export const createDisplayNameForMediaElement =
    createDisplayName(MEDIA_DISPLAY_NAME);
